import { FeatureToggleController } from "./controller";

export const loadFeatureToggles = () => {
  FeatureToggleController();
  return;
};
